package com.example.mystybag.sharedmodels.project.requestModels.merchant

import com.example.mystybag.sharedmodels.AllCommands.STRIPE_GET_ACCOUNT_STATUS
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.Serializable

@Serializable
data class GetStripeAccountStatusRequestModel(
    val merchantId: Long = 0L,
    /**
     * When true the server re-fetches the account from the Stripe API and
     * persists the fresh state before answering (used right after the merchant
     * returns from the hosted onboarding flow). Otherwise the cached DB state
     * is returned.
     */
    val refreshFromStripe: Boolean = false
) : BaseRequestModel(api = STRIPE_GET_ACCOUNT_STATUS)
